<template>
  <div class="container">
    <el-tabs v-model="activeTab" @tab-click="usersTabClick">
      <el-tab-pane label="用户" name="users">
        <el-row>
          <el-input v-model="keywords" placeholder="" clearable style="width: 300px; margin-right: 10px;"
            @clear="usersQueryList"></el-input>
          <el-button @click="usersQueryList" icon="el-icon-search" circle title="搜索"></el-button>
          <el-button @click="addUser" icon="el-icon-plus" circle title="新增"></el-button>
        </el-row>
        <br>
        <el-table :data="usersList" height="650" style="width: 100%">
          <el-table-column prop="account" label="账号" width="100" fixed sortable></el-table-column>
          <el-table-column prop="name_en" label="英文名" width="100" sortable></el-table-column>
          <el-table-column prop="name_cn" label="中文名" width="100" sortable></el-table-column>
          <el-table-column prop="department" label="部门" width="120" sortable></el-table-column>
          <el-table-column prop="email" label="邮箱" width="250" sortable></el-table-column>
          <el-table-column prop="user_type" label="用户类型" width="100"></el-table-column>
          <el-table-column prop="status" label="启用" width="100" sortable>
            <template v-slot="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#dedede"
                @change="usersToggleStatus(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="last_login" label="上次登录时间" width="200" sortable></el-table-column>
          <el-table-column prop="last_ip" label="上次登录IP" width="200"></el-table-column>
          <el-table-column label="操作" min-width="400">
            <template v-slot="scope">
              <el-button type="primary" icon="el-icon-edit" @click="userEdit(scope.row)" circle title="编辑"></el-button>
              <el-button type="danger" icon="el-icon-delete" @click="userDel(scope.row)" circle title="删除"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="创建用户" :visible.sync="addUsersVisable" v-loading="loading" element-loading-text="正在保存, 请稍候">
          <el-form :model="usersForm" label-width="100px" :rules="usersRules" ref="usersForm">
            <el-row>
              <el-col :span="10">
                <el-form-item label="用户名" prop="account">
                  <el-input v-model="usersForm.account" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="usersForm.email"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="usersForm.password" placeholder="8~16位"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="重复密码" prop="repassword">
                  <el-input type="password" v-model="usersForm.repassword" placeholder="重复密码"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="所属部门" prop="department_id">
                  <el-select v-model="usersForm.department_id" filterable clearable placeholder="请选择"
                    style="width: 100%">
                    <el-option v-for="item in departmentList" :key="item.id" :label="item.label" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="用户类型" prop="user_type">
                  <el-select v-model="usersForm.user_type" filterable clearable placeholder="请选择" style="width: 100%">
                    <el-option label="经理" value="2"></el-option>
                    <el-option label="员工" value="3"></el-option>
                    <el-option label="兼职" value="4"></el-option>
                    <el-option label="参观者" value="5"></el-option>
                    <el-option label="开发者" value="9"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="手机">
                  <el-input v-model="usersForm.cellphone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="电话">
                  <el-input v-model="usersForm.telephone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="中文名" prop="name_cn">
                  <el-input v-model="usersForm.name_cn"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="英文名">
                  <el-input v-model="usersForm.name_en"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeAddUsers">关 闭</el-button>
            <el-button type="primary" @click="saveAddUsers">保 存</el-button>
          </span>
        </el-dialog>
        <el-dialog title="编辑用户" :visible.sync="editUsersVisable" v-loading="loading" element-loading-text="正在保存, 请稍候">
          <el-form :model="editUsersForm" label-width="100px" :rules="editUsersRules" ref="editUsersForm">
            <el-row>
              <el-col :span="10">
                <el-form-item label="用户名" prop="account">
                  <el-input v-model="editUsersForm.account" autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="editUsersForm.email"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="密码" prop="password">
                  <el-input type="password" v-model="editUsersForm.password" placeholder="8~16位"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="重复密码" prop="repassword">
                  <el-input type="password" v-model="editUsersForm.repassword" placeholder="重复密码"
                    autocomplete="new-password"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="所属部门" prop="department_id">
                  <el-select v-model="editUsersForm.department_id" filterable clearable placeholder="请选择"
                    style="width: 100%">
                    <el-option v-for="item in departmentList" :key="item.id" :label="item.label" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="用户类型" prop="user_type">
                  <el-select v-model="editUsersForm.user_type" filterable clearable placeholder="请选择"
                    style="width: 100%">
                    <el-option label="经理" value="2"></el-option>
                    <el-option label="员工" value="3"></el-option>
                    <el-option label="兼职" value="4"></el-option>
                    <el-option label="参观者" value="5"></el-option>
                    <el-option label="开发者" value="9"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="手机">
                  <el-input v-model="editUsersForm.cellphone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="电话">
                  <el-input v-model="editUsersForm.telephone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="中文名" prop="name_cn">
                  <el-input v-model="editUsersForm.name_cn"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="英文名">
                  <el-input v-model="editUsersForm.name_en"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeEditUsers">关 闭</el-button>
            <el-button type="primary" @click="saveEditUsers">保 存</el-button>
          </span>
        </el-dialog>
      </el-tab-pane>
      <!-- <el-tab-pane label="角色" name="roles">角色</el-tab-pane>
      <el-tab-pane label="权限" name="permission">权限</el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import Nav from '../Global/Nav.vue'
export default {
  name: 'Users',
  components: {
    Nav
  },
  data() {
    return {
      activeTab: 'users',
      keywords: '',
      usersList: [],
      addUsersVisable: false,
      editUsersVisable: false,
      loading: true,
      usersForm: {
        user_type: '3',
        status: true
      },
      usersRules: {
        account: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'commit' },
          { min: 8, max: 16, message: '密码长度必须8~16位', trigger: 'commit' },
          { validator: this.validatePassword, trigger: 'commit' }
        ],
        repassword: [
          { validator: this.validateRePassword, trigger: 'blur' }
        ]
      },
      editUsersForm: {
        status: true
      },
      editUsersRules: {
        account: [
          { required: true, message: '用户名不能为空', trigger: 'commit' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'commit' }
        ]
      },
      departmentList: []
    }
  },
  mounted() {
    this.usersQueryList();
  },
  methods: {
    validatePassword(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
      if (!regex.test(value)) {
        callback(new Error('密码必须包含字母数字大小写'));
      } else {
        callback();
      }
    },
    validateRePassword(rule, value, callback) {
      if (value !== this.usersForm.password) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    },
    usersTabClick(tab, event) {
      // console.log(tab, event);
    },
    usersQueryList() {
      this.$axios.get('users/list', {
        params: {
          keywords: this.keywords
        }
      }).then((response) => {
        if (response.data.code === 200) {
          this.usersList = response.data.data.data;
        }
      })
    },
    usersToggleStatus(row, index) {
      let notice = row.status ? '启用' : '禁用';
      this.$confirm('确定' + notice + '该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('users/toggle_status', {
          id: row.id,
          status: row.status
        })
      }).catch(() => {
        this.usersList[index].status = !row.status;
      });
    },
    addUser() {
      this.$axios.get(`basic/data/departments/list?option=1`).then((response) => {
        this.departmentList = response.data.data
      })
      setTimeout(() => {
        this.addUsersVisable = true
      })
    },
    closeAddUsers() {
      this.addUsersVisable = false;
      setTimeout(() => {
        this.usersForm = {
          user_type: '3',
          status: true
        };
      })
    },
    saveAddUsers() {
      this.$refs.usersForm.validate(valid => {
        if (valid) {
          this.$axios.post('users/save', this.usersForm).then((response) => {
            if (response.data.code === 200) {
              this.addUsersVisable = false;
              this.$notify({
                type: 'success',
                title: '提示',
                message: '添加成功!'
              })
              this.usersQueryList();
              setTimeout(() => {
                this.usersForm = {
                  user_type: '3',
                  status: true
                };
              })
            } else {
              this.$notify({
                type: 'failed',
                title: '操作失败',
                message: response.data.data
              })
            }
          })
        }
      })
    },
    userEdit(row) {
      this.$axios.get(`basic/data/departments/list?option=1`).then((response) => {
        this.departmentList = response.data.data
      })
      setTimeout(() => {
        this.editUsersVisable = true;
        this.$axios.get(`users/detail?id=` + row.id).then((response) => {
          if (response.data.code === 200) {
            this.editUsersForm = response.data.data
          } else {
            this.$notify({
              type: 'failed',
              title: '错误',
              message: response.data.data
            })
          }
        });
      })
    },
    closeEditUsers() {
      this.editUsersVisable = false;
      setTimeout(() => {
        this.editUsersForm = {
          status: true
        };
      })
    },
    saveEditUsers() {
      this.$refs.editUsersForm.validate(valid => {
        if (valid) {
          this.$axios.post('users/save', this.editUsersForm).then((response) => {
            if (response.data.code === 200) {
              this.addUsersVisable = false;
              this.$notify({
                type: 'success',
                title: '提示',
                message: '保存成功!'
              })
              this.editUsersVisable = false;
              this.usersQueryList();
              setTimeout(() => {
                this.usersForm = {
                  status: true
                };
              })
            } else {
              this.$notify({
                type: 'failed',
                title: '操作失败',
                message: response.data.data
              })
            }
          })
        }
      })
    },
    userDel(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('users/delete', {
          id: row.id
        }).then((response) => {
          let code = response.data.code;
          if (code === 200) {
            this.$notify({
              type: 'success',
              title: '提示',
              message: '删除成功!'
            });
            this.usersQueryList();
          } else {
            this.$notify({
              title: 'failed',
              message: response.data.data,
              type: 'error'
            })
          }
        })
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Modules/Users.vue